import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { LayoutUtilsService } from '@vip/core';
import { ClienteFacade, ClienteTokenService } from '@vip/state/cliente';
import { Observable, of } from 'rxjs';
import { map, tap } from 'rxjs/operators';

@Injectable()
export class CompletarCadastroGuard implements CanActivate {
  constructor(
    private clienteFacade: ClienteFacade,
    private router: Router,
    private clienteToken: ClienteTokenService,
    private layoutUtils: LayoutUtilsService,
  ) {}

  canActivate(): Observable<boolean> | boolean {
    if (this.clienteToken.getToken() === '' || !this.layoutUtils.isDesktop()) {
      return true;
    }

    const nav = this.router.getCurrentNavigation();
    const state = nav?.extras?.state as
      | { cadastroIncompleto?: boolean }
      | undefined;

    if (state && state.cadastroIncompleto !== undefined) {
      return !state.cadastroIncompleto;
    }

    return this.clienteFacade.cadastroIncompleto().pipe(
      tap(({ data }) => {
        if (data) this.router.navigateByUrl('/');
      }),
      map(({ data }) => !data),
    );
  }
}
